const ResidentialPlanTypes = {
  ALL: [0, 1, 2, 3, 5],
  ADD: [0],
  EDIT: [1],
  DELETE: [2],
  READ: [3],
  APPROVE: [5]
}

export default ResidentialPlanTypes
